import defaultsDeep from 'lodash/defaultsDeep';

export function getUIConfig(uiConfig = {}) {
	return defaultsDeep({}, uiConfig, {
		showToolbar: true,
		showViewSwitcher: true,
		showFilters: true
	});
}
